import { Component, Inject, OnInit } from '@angular/core';

import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SwalService } from '@shared/utils/swal.service';

import { RolRequest } from '@shared/interfaces/request/rolRequest';
import { UserService } from '@pages/user/services/user.service';
import { RolService } from '@pages/rol/services/rol.service';

@Component({
  selector: 'app-rol-form',
  templateUrl: './rol-form.component.html',
  styleUrls: ['./rol-form.component.css'],
})
export class RolFormComponent implements OnInit {
  private _user: string = JSON.parse(sessionStorage.getItem('Usser'));
  public loading: boolean = false;

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<RolFormComponent>,
    private _swalService: SwalService,
    private _rolServices: RolService,
    private _userServices: UserService,
    @Inject(MAT_DIALOG_DATA) public model: RolRequest
  ) {
    if (this.model !== null) {
      const setModel = {
        id: model.id,
        description: model.description,
        active: model.active,
        userCreated: model.userCreated,
        dateCreated: model.dateCreated,
        userModified: this._user,
        definition: model.definition
      };
      this.form.setValue(setModel);
    }
  }

  form = this._fb.group({
    id: 0,
    description: ['', Validators.required],
    active: [true],
    userCreated: this._user,
    dateCreated: '2021-08-03T17:16:40',
    userModified: this._user,
    definition: ['']
  });

  ngOnInit(): void {}

  close() {
    this._dialogRef.close();
  }

  create(model: RolRequest) {
    if (this.form.valid) {
      this.loading = true;
      this._rolServices.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else {
          console.log(res.message);
          this._swalService.error('No Agregado');
        }
      });
    }
  }

  update(model: RolRequest) {
    if (this.form.valid) {
      this.loading = true;
      this._rolServices.update(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else {
          console.log(res.message);
          this._swalService.error('No Editado');
        }
      });
    }
  }

  //#region Get Fb
  formValue(value: string) {
    return this.form.get(value);
  }
  //#endregion
}
